import React, { useState } from "react";

import { MemberTabs, MemberTabsProps } from "../../../../../People/Members";
import { Member } from "./Member";
import { Team } from "./Team";

export const MembersAndTeams = () => {
  const [currentActive, setCurrentActive] = useState<MemberTabsProps["currentActive"]>("members");

  return (
    <div>
      <MemberTabs currentActive={currentActive} setCurrentActive={setCurrentActive} />

      {currentActive === "members" ? <Member /> : <Team />}
    </div>
  );
};
